exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs[data-v-4b4e2d6c] {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.tabs .tabs-row[data-v-4b4e2d6c] {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 16px;\n  margin: 0 40px;\n  overflow: hidden;\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n.tabs .content-slot[data-v-4b4e2d6c] {\n  width: 100%;\n}", ""]);

// exports
